import Layout from '../../components/Layout';
import SectionHeading from '../../components/SectionHeading';
import { useSiteContent } from '../../content/ContentContext';

export default function AboutPage() {
  const {
    content: { site },
  } = useSiteContent();

  return (
    <Layout>
      <section className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-24">
        <div>
          <SectionHeading eyebrow="About B&B" title={site.aboutTitle} description={site.aboutDescription} />
          <div className="space-y-5 text-base leading-8 text-slate-700">
            {site.aboutStory.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          {site.aboutImages.map((image, index) => (
            <img
              key={`${image.src}-${index}`}
              src={image.src}
              alt={image.alt}
              className={`w-full rounded-[2rem] object-cover shadow-lg ${index === 0 ? 'h-full min-h-[260px] sm:row-span-2' : 'h-60'}`}
            />
          ))}
        </div>
      </section>

      <section className="bg-slate-50">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
          <SectionHeading eyebrow="What Matters" title={site.valuesTitle} center />
          <div className="grid gap-6 md:grid-cols-3">
            {site.values.map((value) => (
              <div key={value.title} className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
                <h3 className="text-xl font-black text-slate-900">{value.title}</h3>
                <p className="mt-3 text-sm leading-7 text-slate-600">{value.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
